import { Box, Typography } from '@mui/material';
import { AddShoppingCart, Close } from '@mui/icons-material';
import { CustomButton, HorizontalForm } from '../../../common/components';
import {
  CONSOLIDATED_SUPPLY_TEXTS as TEXTS,
} from '../../supply-orders/constants/consolidatedSupplyTexts';

/** Revela las acciones de selección sin desplazar bruscamente la tabla. */
const InternalOrdersSelectionToolbar = ({ count, onGenerate, onClear }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateRows: count ? '1fr' : '0fr',
      opacity: count ? 1 : 0,
      visibility: count ? 'visible' : 'hidden',
      transition: 'grid-template-rows 220ms ease, opacity 180ms ease, visibility 220ms',
      '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
    }}
    aria-hidden={!count}
  >
    <Box sx={{ overflow: 'hidden', minHeight: 0 }}>
      <HorizontalForm
        withBorder={false}
        role="toolbar"
        aria-label={TEXTS.action}
        sx={{
          px: 2.5,
          py: 1.25,
          gap: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          flexDirection: 'row',
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiButton-root': { height: 42, fontSize: 14, whiteSpace: 'nowrap' },
        }}
      >
        <Typography
          component="span"
          role="status"
          aria-live="polite"
          sx={{ fontSize: 14, fontWeight: 700, lineHeight: 1.4, color: 'primary.main' }}
        >
          {TEXTS.selected(count)}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
          <CustomButton
            variant="text"
            startIcon={<Close />}
            onClick={onClear}
            tabIndex={count ? 0 : -1}
          >
            {TEXTS.clear}
          </CustomButton>
          <CustomButton
            variant="base"
            startIcon={<AddShoppingCart />}
            onClick={onGenerate}
            tabIndex={count ? 0 : -1}
          >
            {TEXTS.action}
          </CustomButton>
        </Box>
      </HorizontalForm>
    </Box>
  </Box>
);

export default InternalOrdersSelectionToolbar;
